/**
 * localStorage keys for variant Spin/Grid preview, shared by:
 * preview_spin_controller, navbar_actions_controller, variant_embed_aside_controller.
 */
export const VARIANT_PREVIEW_MODE_KEY_PREFIX = "variant_preview_mode_"
export const GRID_THUMBS_ALT_TEXT_PREF_PREFIX = "variant_grid_thumbs_alt_text_"
export const GRID_SELECTED_IMAGE_KEY_PREFIX = "variant_grid_selected_image_"
